/**
 * Splits the Music section's fields by shape, never by key name.
 *
 *   cards   the list field whose options carry `children` — a card is a
 *           grouping header, so what gets stored is always a child's id, or
 *           the card's own id when it has none
 *   linkOf  option id -> text field that drives it. A card with no children
 *           is link-driven when the section holds a `<option id>_url` field:
 *           pasting a link implies the category, clearing it releases it
 *   chips   any other list field with options, rendered as chips
 *   noteOf  chip field key -> its `<key>_text` companion, revealed once
 *           something is excluded
 */
export const splitMusicFields = section => {
  const fields = section && section.fields || [];
  const lists = fields.filter(f => f.kind === 'list');
  const texts = fields.filter(f => f.kind === 'text');
  const cards = lists.find(f => (f.options || []).some(o => (o.children || []).length));
  const linkOf = {};
  if (cards) {
    (cards.options || []).forEach(option => {
      if ((option.children || []).length) return;
      const paired = texts.find(t => t.key === `${option.id}_url`);
      if (paired) linkOf[option.id] = paired;
    });
  }
  const chips = lists.filter(f => f !== cards && (f.options || []).length);
  const noteOf = {};
  chips.forEach(chip => {
    const paired = texts.find(t => t.key === `${chip.key}_text`);
    if (paired) noteOf[chip.key] = paired;
  });
  const consumed = [cards, ...Object.values(linkOf), ...chips, ...Object.values(noteOf)].filter(Boolean);
  return {
    cards,
    linkOf,
    chips,
    noteOf,
    rest: fields.filter(f => !consumed.includes(f)),
    isMusic: !!cards
  };
};

/** The `list` query of an embed URL, or null. Never parsed by regex. */
export const listIdOf = thing => {
  try {
    return new URL(thing.embed_url).searchParams.get('list');
  } catch (e) {
    return null;
  }
};
